import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TradingPage from './pages/TradingPage';
import MissionsPage from './pages/MissionsPage';
import PartnersPage from './pages/PartnersPage';
import RescuedPage from './pages/RescuedPage';
import MerchandisePage from './pages/MerchandisePage';
import CompaniesPage from './pages/CompaniesPage';
import ExperiencePage from './pages/ExperiencePage';
import DossierPage from './pages/DossierPage';
import AuditPage from './pages/AuditPage';
import MandatePage from './pages/MandatePage';
import ContractPage from './pages/ContractPage';
import ManufacturerAgreementPage from './pages/ManufacturerAgreementPage';
import LoginPage from './pages/LoginPage';
import ExtranetPage from './pages/ExtranetPage';
import AdminPage from './pages/AdminPage';
import { Toaster } from './components/ui/toaster';
import { LanguageProvider } from './i18n/LanguageContext';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';

function App() {
  useEffect(() => {
    document.title = 'Yuville International inc.';
    // Suppress opaque cross-origin "Script error." from third-party embeds (TradingView)
    const handler = (e) => {
      const msg = (e?.message || '').toLowerCase();
      if (msg.includes('script error') || (e?.filename && !e.filename.includes(window.location.host))) {
        e.stopImmediatePropagation();
        return true;
      }
      return false;
    };
    window.addEventListener('error', handler, true);
    return () => window.removeEventListener('error', handler, true);
  }, []);
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/trading" element={<TradingPage />} />
              <Route path="/missions" element={<MissionsPage />} />
              <Route path="/partenaires" element={<PartnersPage />} />
              <Route path="/rescapes" element={<RescuedPage />} />
              <Route path="/marchandises" element={<MerchandisePage />} />
              <Route path="/entreprises" element={<CompaniesPage />} />
              <Route path="/experience" element={<ExperiencePage />} />
              <Route path="/dossier/:rfqId" element={<DossierPage />} />
              <Route path="/dossier/:rfqId/audit/:mid" element={<AuditPage />} />
              <Route path="/mandat/:rfqId" element={<MandatePage />} />
              <Route path="/mandat/:rfqId/signature-complete" element={<MandatePage />} />
              <Route path="/contrat/:rfqId" element={<ContractPage />} />
              <Route path="/contrat/:rfqId/signature-complete" element={<ContractPage />} />
              <Route path="/manufacturier/:mid" element={<ManufacturerAgreementPage />} />
              <Route path="/manufacturier/:mid/signature-complete" element={<ManufacturerAgreementPage />} />
              <Route path="/extranet/login" element={<LoginPage />} />
              <Route path="/extranet" element={<ProtectedRoute><ExtranetPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
